var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 52.5V47.5C42.5 44.8478 41.4464 42.3043 39.5711 40.4289C37.6957 38.5536 35.1522 37.5 32.5 37.5H12.5C9.84784 37.5 7.3043 38.5536 5.42893 40.4289C3.55357 42.3043 2.5 44.8478 2.5 47.5V52.5",
    stroke: "#069B7B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 27.5C28.0228 27.5 32.5 23.0228 32.5 17.5C32.5 11.9772 28.0228 7.5 22.5 7.5C16.9772 7.5 12.5 11.9772 12.5 17.5C12.5 23.0228 16.9772 27.5 22.5 27.5Z",
    stroke: "#069B7B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 52.4992V47.4992C57.4983 45.2835 56.7609 43.1311 55.4034 41.38C54.0459 39.6289 52.1453 38.3781 50 37.8242",
    stroke: "#069B7B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 7.82422C42.151 8.37497 44.0576 9.62597 45.4191 11.38C46.7806 13.134 47.5196 15.2913 47.5196 17.5117C47.5196 19.7321 46.7806 21.8894 45.4191 23.6434C44.0576 25.3975 42.151 26.6485 40 27.1992",
    stroke: "#069B7B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersAdmin);
export default __webpack_public_path__ + "static/media/users-admin.7cd2e3eee41ef587b929f9ec8cb45584.svg";
export { ForwardRef as ReactComponent };